import request from '../../../shared/request'

export function getJobStopCalls(job_id) {
  return request(`/job/stop_calls/${job_id}/`)
}

export function createStopCall(payload) {
  return request(`/job/stop_calls`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateStopCall(payload) {
  return request(`/job/stop_calls/${payload.stop_call_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteStopCall(payload) {
  return request(`/job/stop_calls/${payload.stopCallId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// ATTACHMENTS
export function uploadStopCallAttachments(payload) {
  return request(`/job/stop_calls/${payload.stopCallId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function fetchStopCallAttachments(stopCallId) {
  return request(`/job/stop_calls/${stopCallId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/stop_calls/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: { description: payload.description },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteStopCallAttachment(payload) {
  return request(`/job/stop_calls/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// NOTES
export function getStopCallNotes(stop_call_id) {
  return request(`/job/stop_calls/notes/${stop_call_id}/`)
}

export function createNote(payload) {
  return request(`/job/stop_calls/notes/${payload.stopCallId}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateNote(payload) {
  return request(`/job/stop_calls/notes/${payload.note_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteNote(payload) {
  return request(`/job/stop_calls/notes/${payload.note_id}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/stopCalls.js